import React, { useState, useEffect } from "react";
import CountUp from "react-countup";
import {
  File,
  User,
  UserCheck,
} from "feather-icons-react/build/IconComponents";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import { apiClient } from "../../services/apiClient";

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    sales: { total_amount: 0, due_amount: 0 },
    purchases: { total_amount: 0, due_amount: 0 },
    expenses: 0,
    counts: { customers: 0, suppliers: 0, branches: 0, products: 0 },
    latest_products: [],
    expiring_products: [],
    outofstock_products: [],
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const apiData = await apiClient.get("/dashboard-data");
        if (apiData.success) {
          const response = apiData.data;
          setDashboardData({
            sales: response.sales || { total_amount: 0, due_amount: 0 },
            purchases: response.purchases || { total_amount: 0, due_amount: 0 },
            expenses: response.expenses || 0,
            counts: response.counts || {
              customers: 0,
              suppliers: 0,
              branches: 0,
              products: 0,
            },
            latest_products: response.latest_products || [],
            expiring_products: response.expiring_products || [],
            outofstock_products: response.outofstock_products || [],
          });
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };
    fetchDashboardData();
  }, []);

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="https://odabill.com/assets/img/icons/dash1.svg"
                      alt="img"
                      loading="lazy"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={dashboardData.purchases.due_amount}
                      duration={3}
                      prefix="PKR "
                    />
                  </h5>
                  <h6>Total Purchase Due</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash1 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="https://odabill.com/assets/img/icons/dash2.svg"
                      alt="img"
                      loading="lazy"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={dashboardData.sales.due_amount}
                      duration={3}
                      prefix="PKR "
                    />
                  </h5>
                  <h6>Total Sales Due</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash2 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="https://odabill.com/assets/img/icons/dash3.svg"
                      alt="img"
                      loading="lazy"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={dashboardData.sales.total_amount}
                      duration={3}
                      prefix="PKR "
                      decimals={1}
                    />
                  </h5>
                  <h6>Total Sale Amount</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-widget dash3 w-100">
                <div className="dash-widgetimg">
                  <span>
                    <ImageWithBasePath
                      src="https://odabill.com/assets/img/icons/dash4.svg"
                      alt="img"
                      loading="lazy"
                    />
                  </span>
                </div>
                <div className="dash-widgetcontent">
                  <h5>
                    <CountUp
                      start={0}
                      end={dashboardData.expenses}
                      duration={3}
                      prefix="PKR "
                    />
                  </h5>
                  <h6>Total Expense Amount</h6>
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count">
                <div className="dash-counts">
                  <h4>{dashboardData.counts.customers}</h4>
                  <h5>Customers</h5>
                </div>
                <div className="dash-imgs">
                  <User />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das1">
                <div className="dash-counts">
                  <h4>{dashboardData.counts.suppliers}</h4>
                  <h5>Suppliers</h5>
                </div>
                <div className="dash-imgs">
                  <UserCheck />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das2">
                <div className="dash-counts">
                  <h4>{dashboardData.counts.branches}</h4>
                  <h5>Branches</h5>
                </div>
                <div className="dash-imgs">
                  <ImageWithBasePath
                    src="https://odabill.com/assets/img/icons/file-text-icon-01.svg"
                    className="img-fluid"
                    alt="icon"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
            <div className="col-xl-3 col-sm-6 col-12 d-flex">
              <div className="dash-count das3">
                <div className="dash-counts">
                  <h4>{dashboardData.counts.products}</h4>
                  <h5>Products</h5>
                </div>
                <div className="dash-imgs">
                  <File />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 col-sm-12 col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Recent Products</h4>
                </div>
                <div
                  className="card-body"
                  style={{ height: "400px", backgroundColor: "white" }}
                >
                  <div
                    className="table-responsive dataview"
                    style={{ height: "367px", overflowY: "auto" }}
                  >
                    <table
                      className="table dashboard-expired-products"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "5%" }}>#</th>
                          <th style={{ width: "35%" }}>Products</th>
                          <th style={{ width: "35%" }}>SKU</th>
                          <th style={{ width: "25%" }}>Price</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData.latest_products.length > 0 ? (
                          dashboardData.latest_products.map(
                            (product, index) => (
                              <tr key={product.id}>
                                <td>{index + 1}</td>
                                <td className="productimgname">
                                  <Link to="#" className="product-img">
                                    <ImageWithBasePath
                                      src={
                                        product.image
                                          ? JSON.parse(product.image)[0]
                                          : "https://odabill.com/assets/img/product/noimage.png"
                                      }
                                      alt="product"
                                      className="prod_image"
                                      loading="lazy"
                                    />
                                  </Link>
                                  <Link to="#">
                                    <span className="wrap-text">
                                      {product.name}
                                    </span>
                                  </Link>
                                </td>
                                <td>
                                  <span className="wrap-text">
                                    {product.sku}
                                  </span>
                                </td>
                                <td>
                                  <span className="wrap-text">
                                    {product.price
                                      ? `PKR ${parseFloat(
                                          product.price
                                        ).toFixed(2)}`
                                      : "N/A"}
                                  </span>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <tr>
                            <td colSpan="12" style={{ textAlign: "center" }}>
                              No products found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-6 col-sm-12 col-12">
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Expired Products</h4>
                </div>
                <div
                  className="card-body"
                  style={{ height: "400px", backgroundColor: "white" }}
                >
                  <div
                    className="table-responsive dataview"
                    style={{ height: "367px", overflowY: "auto" }}
                  >
                    <table
                      className="table dashboard-expired-products"
                      style={{ width: "100%" }}
                    >
                      <thead>
                        <tr>
                          <th style={{ width: "35%" }}>Product</th>
                          <th style={{ width: "30%" }}>SKU</th>
                          <th style={{ width: "15%" }}>Manufactured Date</th>
                          <th style={{ width: "15%" }}>Expired Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dashboardData.expiring_products.length > 0 ? (
                          dashboardData.expiring_products.map(
                            (product, index) => (
                              <tr key={index}>
                                <td>
                                  <div className="productimgname">
                                    <Link to="#" className="product-img">
                                      <ImageWithBasePath
                                        src={
                                          product.image
                                            ? JSON.parse(product.image)[0]
                                            : "https://odabill.com/assets/img/product/noimage.png"
                                        }
                                        alt="product"
                                        className="prod_image"
                                        loading="lazy"
                                      />
                                    </Link>
                                    <Link to="#">
                                      <span className="wrap-text">
                                        {product.name}
                                      </span>
                                    </Link>
                                  </div>
                                </td>
                                <td>
                                  <span className="wrap-text">
                                    {product.sku}
                                  </span>
                                </td>
                                <td>
                                  <span className="wrap-text">
                                    {product.manufacturer_date
                                      ? new Date(
                                          product.manufacturer_date
                                        ).toLocaleDateString()
                                      : "N/A"}
                                  </span>
                                </td>
                                <td>
                                  <span className="wrap-text">
                                    {product.expiry_on
                                      ? new Date(
                                          product.expiry_on
                                        ).toLocaleDateString()
                                      : "N/A"}
                                  </span>
                                </td>
                              </tr>
                            )
                          )
                        ) : (
                          <tr>
                            <td colSpan="12" style={{ textAlign: "center" }}>
                              No products found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div> */}

            <div className="row" style={{ paddingRight: "0" }}>
              <div
                className="col-xl-12 col-sm-12 col-12"
                style={{ paddingRight: "0" }}
              >
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">Out of Stock Products</h4>
                  </div>

                  <div
                    className="card-body"
                    style={{ height: "410px", backgroundColor: "white" }}
                  >
                    <div
                      className="table-responsive dataview"
                      style={{ height: "408px", overflowY: "auto" }}
                    >
                      <table
                        className="table dashboard-expired-products"
                        style={{ width: "100%" }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "35%" }}>Product</th>
                            <th style={{ width: "30%" }}>SKU</th>
                            <th style={{ width: "15%" }}>Manufactured Date</th>
                            <th style={{ width: "15%" }}>Quantity</th>
                            <th style={{ width: "15%" }}>Expired Date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dashboardData.outofstock_products.length > 0 ? (
                            dashboardData.outofstock_products.map(
                              (product, index) => (
                                <tr key={index}>
                                  <td>
                                    <div className="productimgname">
                                      <Link to="#" className="product-img">
                                        <ImageWithBasePath
                                          src={
                                            product.image
                                              ? JSON.parse(product.image)[0]
                                              : "https://odabill.com/assets/img/product/noimage.png"
                                          }
                                          alt="product"
                                          className="prod_image"
                                          loading="lazy"
                                        />
                                      </Link>
                                      <Link to="#">
                                        <span className="wrap-text">
                                          {product.name}
                                        </span>
                                      </Link>
                                    </div>
                                  </td>
                                  <td>
                                    <span className="wrap-text">
                                      {product.sku}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="wrap-text">
                                      {product.manufacturer_date
                                        ? new Date(
                                            product.manufacturer_date
                                          ).toLocaleDateString()
                                        : "N/A"}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="wrap-text">
                                      {product.quantity}
                                    </span>
                                  </td>
                                  <td>
                                    <span className="wrap-text">
                                      {product.expiry_on
                                        ? new Date(
                                            product.expiry_on
                                          ).toLocaleDateString()
                                        : "N/A"}
                                    </span>
                                  </td>
                                </tr>
                              )
                            )
                          ) : (
                            <tr>
                              <td colSpan="12" style={{ textAlign: "center" }}>
                                No products found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
